<template>
  <div class="preloader-intro-bar">
    <span class="value-left">
      <!-- <transition name="preloader-value-decimal" mode="out-in"> -->
      <em :key="decimal">{{decimal}}</em>
      <!-- </transition> -->
    </span>
    <div class="bar" :style="{
      'transform': 'scale3d(' + percentage / 100 + ', 1, 1) translateY(-50%)'
    }"></div>
    <span class="value-dynamic" :style="{'transform': 'translate3d(' + percentage + '%, -50%, 0)'}">
      <!-- <transition name="preloader-value-units" mode="out-in"> -->
      <em :key="units">{{units}}</em>
      <!-- </transition> -->
      <i>%</i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'PreloaderIntroBar',

  props: {
    percentage: {
      type: Number,
      required: false,
      default: 0
    }
  },

  computed: {
    decimal () {
      if (this.percentage < 10) {
        return '0'
      } else {
        return this.percentage.toString().split('')[0]
      }
    },

    units () {
      if (this.percentage < 10) {
        return this.percentage.toString().split('')[0]
      } else {
        return this.percentage.toString().split('')[1]
      }
    }
  }
}
</script>

<style scoped lang="scss">

.preloader-intro-bar {
  display: block;
  position: relative;
  height: 30px;

  @include breakpoint('md-and-up') {
    height: 60px;
  }

  .bar {
    width: calc(100% - 60px);
    height: 1px;

    top: 50%;
    left: 20px;

    position: absolute;

    background-color: $c-text-grey;
    transform-origin: left;
    backface-visibility: hidden;

    @include breakpoint('md-and-up') {
      left: 50px;
      width: calc(100% - 175px);
      height: 1px;
    }
  }

  span {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 15px;
    left: 0;
    color: $c-text-grey;
    font-family: 'Lora', sans-serif;
    font-size: 24px;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    height: 100%;

    @include breakpoint('md-and-up') {
      font-size: 40px;
      letter-spacing: 0;
      width: 40px;
      height: 40px;
      line-height: 1;
    }

    em {
      display: block;
      font-style: normal;
      position: absolute;
      top: 0;
      left: 0;
      text-align: center;
      backface-visibility: hidden;
    }

    i {
      position: absolute;
      left: 15px;
      top: 0;
      font-style: normal;
      text-align: center;

      @include breakpoint('md-and-up') {
        left: 40px;
      }
    }

    &.value-dynamic {
      width: calc(100% - 60px);
      left: 30px;

      @include breakpoint('md-and-up') {
        left: 50px;
        width: calc(100% - 150px);
      }
    }
  }
}

.preloader-value-decimal-enter-active,
.preloader-value-decimal-leave-active {
  transition: opacity 0.3s $ease-out-cubic, transform 0.3s $ease-out-cubic;
}

.preloader-value-decimal-enter {
  opacity: 0;
}

.preloader-value-decimal-leave-to {
  transform: translateY(-0.5em);
  opacity: 0;
}

.preloader-value-units-enter-active,
.preloader-value-units-leave-active {
  transition: opacity 0.03s;
}

.preloader-value-units-enter {
  opacity: 0;
}

.preloader-value-units-leave-to {
  opacity: 0;
}

</style>
